export default __webpack_public_path__ + "static/media/icon_delete.df83e949.svg";